import { render, staticRenderFns } from "./DeleteContact.vue?vue&type=template&id=779d0f07&scoped=true"
import script from "./DeleteContact.vue?vue&type=script&lang=js"
export * from "./DeleteContact.vue?vue&type=script&lang=js"
import style0 from "./DeleteContact.vue?vue&type=style&index=0&id=779d0f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779d0f07",
  null
  
)

export default component.exports